'use client'

import Link from 'next/link'
import { Card } from '@/components/ui/card'
import styles from './asset-card.module.scss'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const assetCardVariants = cva(styles.card, {
  variants: {
    aspect: {
      default: 'tw-w-full tw-h-full',
      video: 'tw-aspect-video',
      square: 'tw-aspect-square',
      'ultra-wide': 'tw-aspect-ultra-wide',
    },
    size: {
      default: '!tw-max-w-full',
      md: styles.md,
      sm: '',
    },
  },
  defaultVariants: {
    aspect: 'default',
    size: 'default',
  },
})

export type AssetCardProps = {
  className?: string
  title?: string
  description?: string
  image?: string | null
  link: string
  selected?: boolean
  onLinkClick?: () => void
} & VariantProps<typeof assetCardVariants>

const AssetCard = ({
  className,
  title,
  description,
  image,
  link,
  size,
  aspect,
  selected,
  onLinkClick,
  ...props
}: AssetCardProps) => {
  return (
    <Card
      data-slot="asset-card"
      className={cn(
        'asset-card',
        assetCardVariants({ size, aspect }),
        {
          [styles.selected]: Boolean(selected),
        },
        className,
        { ...props }
      )}
    >
      <Link
        href={link}
        className="tw-h-full tw-w-full"
        onClick={() => {
          if (onLinkClick) {
            onLinkClick()
          }
        }}
      >
        <picture className={styles.image}>
          <img src={image || ''} alt={title} className={styles.imageContent} />
        </picture>
        <div className={styles.title}>{title}</div>
        <div className={styles.blurry_bg}></div>
      </Link>
    </Card>
  )
}
AssetCard.displayName = 'AssetCard'

export { AssetCard, assetCardVariants }
